import $ from "jquery";
import BurgerBtn from './lhs/transverse/burgerBtn';
import SearchPanel from './lhs/transverse/searchPanel';
import NavPanelDesktop from './lhs/transverse/navPanelDesktop';
import NavPanelMobile from './lhs/auth/navPanelMobile';

const SELECTOR = {
    MAIN_CONTENT: '.dcw_main',
    MOBILE_BURGER: '.js-header-burger',
    MOBILE_BURGER_CONTENT: '.js-burger-content',
    PANEL_SEACH: '.js-nav-search',
    NAV_MOBILE_AUTHENTICATED: '.js-mobile-nav-codeco',
    NAV_MOBILE_AUTHENTICATED_AREA: '.js-mobile-menu-codeco'
};

const PREFIX = {
    GSA: 'search-gsa'
}

let domCache;

// COMPONENTS
var burgerBtn, navPanelMobile, panelSearch, navPanelDesktop = null;

export function initHeaderLhsUnauthDesktop(SelectorHeaderRoot) {
    panelSearch = new SearchPanel(SELECTOR.PANEL_SEACH, PREFIX.GSA, false);

    navPanelDesktop = new NavPanelDesktop();
    navPanelDesktop.init();

    domCache = getDomCache(SelectorHeaderRoot);
}

export function initHeaderLhsUnauthMobile(SelectorHeaderRoot) {
    panelSearch = new SearchPanel(SELECTOR.PANEL_SEACH, PREFIX.GSA, true);
    burgerBtn = new BurgerBtn(SELECTOR.MOBILE_BURGER, SELECTOR.MOBILE_BURGER_CONTENT);
    burgerBtn.init();
    /*if (isAuthenticated()) {
        initAuthenticatedNavigationMobile();
    }*/

    navPanelMobile = new NavPanelMobile();
    navPanelMobile.init();

    domCache = getDomCache(SelectorHeaderRoot);
    marginContent();
}

function getDomCache(SelectorHeaderRoot) {
    return {
        headerRoot: document.querySelector(SelectorHeaderRoot)
    };
}

/*
    [TODO] Check if deprecated
 */
function initAuthenticatedNavigationMobile() {
    $(SELECTOR.NAV_MOBILE_AUTHENTICATED_AREA).append($(SELECTOR.NAV_MOBILE_AUTHENTICATED).children());
}

/*
    [TODO] Check if deprecated
 */
function isAuthenticated() {
    var sasInf = document.getElementById('sas_user_info');
    if (sasInf) {
        var sasHtml = sasInf.innerHTML;
        try {
            var sasJs = JSON.parse(sasHtml.trim());
            if (sasJs && sasJs.IdStat) {
                return true;
            }
        }  catch (e) {
           return false;
        }
    }
    return false;
}

function marginContent() {
    var marginHead = domCache.headerRoot.clientHeight + 24;
    document.querySelector(SELECTOR.MAIN_CONTENT).style.marginTop = marginHead + "px";
}


// WEBPACK FOOTER //
// ./src/components/header/headerLhsUnauth.js